import { createApp, Transition  } from 'vue';
//import Vue from 'vue'
import App from './App.vue';
import router from './router';
//import RouterView from 'vue-router';
import i18n from '@/helper/i18n'
import { store } from '@/store'
// import Paginate from 'vuejs-paginate-next';
//import { BootstrapVue, TablePlugin } from 'bootstrap-vue';
// import Loading from 'vue3-loading-overlay';
import excel from 'vue-excel-export'
import VueDatePicker from '@vuepic/vue-datepicker';
import $ from 'jquery';
window.$ = $


// createApp(App).mount("#app");
import "../node_modules/admin-lte/plugins/fontawesome-free/css/all.min.css"
import '../node_modules/admin-lte/dist/css/adminlte.min.css'
import '../node_modules/admin-lte/plugins/icheck-bootstrap/icheck-bootstrap.min.css'
import '../node_modules/admin-lte/plugins/select2-bootstrap4-theme/select2-bootstrap4.min.css'
import '../node_modules/admin-lte/plugins/select2/css/select2.min.css'
import '../node_modules/vue3-loading-overlay/dist/vue3-loading-overlay.css';

import '../node_modules/magnific-popup/dist/magnific-popup.css';
import '../node_modules/magnific-popup/dist/jquery.magnific-popup.js';

import '../node_modules/@vuepic/vue-datepicker/dist/main.css';
// import '../node_modules/admin-lte/plugins/jquery/jquery.js'
// import '../node_modules/admin-lte/plugins/jquery/jquery.min.js'
import '../node_modules/admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js'
import '../node_modules/admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js'
import '../node_modules/admin-lte/plugins/select2/js/select2.full.min.js'
import '../node_modules/admin-lte/dist/js/adminlte.js'
import '../node_modules/admin-lte/plugins/daterangepicker/daterangepicker.js'

// import '../node_modules/admin-lte/plugins/inputmask/jquery.inputmask.min.js'

import '../node_modules/admin-lte/plugins/datatables/jquery.dataTables.min.js'
import '../node_modules/admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js'
import '../node_modules/admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js'
import '../node_modules/admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js'
import '../node_modules/admin-lte/plugins/datatables-buttons/js/dataTables.buttons.min.js'
import '../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.bootstrap4.min.js'
import '../node_modules/admin-lte/plugins/jszip/jszip.min.js'
import '../node_modules/admin-lte/plugins/pdfmake/pdfmake.min.js'
import '../node_modules/admin-lte/plugins/pdfmake/vfs_fonts.js'
import '../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.html5.min.js'
import '../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.print.min.js'
import '../node_modules/admin-lte/plugins/datatables-buttons/js/buttons.colVis.min.js'
import '../node_modules/admin-lte/plugins/bootstrap-switch/js/bootstrap-switch.min.js'
import '../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js'

import '../node_modules/admin-lte/plugins/summernote/summernote-bs4.js'
import '../node_modules/admin-lte/plugins/summernote/summernote-bs4.css'
import '../node_modules/admin-lte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css'
import '../node_modules/tabulator-tables/dist/css/tabulator.min.css'
import '../node_modules/admin-lte/plugins/daterangepicker/daterangepicker.css'


// import '../node_modules/admin-lte/dist/js/demo.js'

import TheLoader from './components/shareComponents/TheLoader.vue';

const app = createApp(App);
app.config.productionTip = false;
app.use(router);
app.use(store);
app.use(i18n);
app.component('transition', Transition);
//app.use(RouterView);
app.use(excel);
// app.use(Paginate);
app.component('VueDatePicker', VueDatePicker);
app.component('TheLoader', TheLoader);
// app.use(Loading, {
// 	// props
// 	color: 'red'
// });
app.mount('#app')

//Thay đổi jQuery ở Summernot từ jQuery --> jquery